module.exports = __webpack_public_path__ + "img/3.441ce210.webp";